import { render, staticRenderFns } from "./MatchProject.vue?vue&type=template&id=50f982ed&scoped=true"
import script from "./MatchProject.vue?vue&type=script&lang=js"
export * from "./MatchProject.vue?vue&type=script&lang=js"
import style0 from "./MatchProject.vue?vue&type=style&index=0&id=50f982ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f982ed",
  null
  
)

export default component.exports